export const sideNavAnalyticsProps = (params: {
  title: string
  href: string
  [key: string]: unknown
}) => ({
  event: '$track_side_menu_click',
  params,
})
